// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pool-picks-matchup-box {
  display: flex;
  flex-direction: column;
  border: 1px solid #002129;
  border-radius: 16px;
  width: 96% !important;
  max-width: 500px;
  padding: 8px;
  margin-bottom: 24px !important;
}
@media (max-width: 900px) {
  .pool-picks-matchup-box {
    max-width: 300px;
  }
}
.pool-picks-matchup-box .pool-picks-matchup-box-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  padding: 0 8px;
  margin-bottom: 12px !important;
}
@media (min-width: 900px) {
  .pool-picks-matchup-box .pool-picks-matchup-box-row {
    width: 100%;
    max-width: 275px;
    padding: 0;
  }
}
.pool-picks-matchup-box .pool-picks-matchup-box-row .team-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
@media (min-width: 900px) {
  .pool-picks-matchup-box .pool-picks-matchup-box-row .team-group {
    gap: 16px;
  }
}
.pool-picks-matchup-box .pool-picks-matchup-box-seed {
  width: 18px;
  height: 18px;
  background-color: #002129;
  border: 1px solid #CA942E;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 900px) {
  .pool-picks-matchup-box .pool-picks-matchup-box-seed {
    width: 32px;
    height: 32px;
  }
}
.pool-picks-matchup-box .pool-picks-matchup-box-seed p {
  font-size: 12px;
  font-weight: 500;
  color: #CD942E;
  margin: 0;
}
@media (min-width: 900px) {
  .pool-picks-matchup-box .pool-picks-matchup-box-seed p {
    font-size: 18px;
  }
}
.pool-picks-matchup-box .pool-picks-matchup-box-team img {
  width: 32px;
  height: 32px;
}
@media (min-width: 900px) {
  .pool-picks-matchup-box .pool-picks-matchup-box-team img {
    width: 48px;
    height: 48px;
  }
}
.pool-picks-matchup-box .pool-picks-matchup-box-vs {
  font-size: 12px;
  font-weight: 500;
  color: #002129;
}
@media (min-width: 900px) {
  .pool-picks-matchup-box .pool-picks-matchup-box-vs {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BracketGames/BracketPoolPicks/BracketPoolPicks.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;AACJ;AACI;EAVJ;IAWY,gBAAA;EAEV;AACF;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,8BAAA;AAER;AAAQ;EAXJ;IAYQ,WAAA;IACA,gBAAA;IACA,UAAA;EAGV;AACF;AADQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAGZ;AADY;EALJ;IAMQ,SAAA;EAId;AACF;AAAI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAER;AAAQ;EAVJ;IAWQ,WAAA;IACA,YAAA;EAGV;AACF;AADQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAGZ;AADY;EANJ;IAOQ,eAAA;EAId;AACF;AACQ;EACI,WAAA;EACA,YAAA;AACZ;AACY;EAJJ;IAKQ,WAAA;IACA,YAAA;EAEd;AACF;AAEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAEQ;EALJ;IAMQ,eAAA;EACV;AACF","sourcesContent":[".pool-picks-matchup-box {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #002129;\n    border-radius: 16px;\n    width: 96% !important;\n    max-width: 500px;\n    padding: 8px;\n    margin-bottom: 24px !important;\n\n    @media (max-width: 900px) {\n            max-width: 300px;\n    }\n\n    .pool-picks-matchup-box-row {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        max-width: 200px;\n        margin: 0 auto;\n        padding: 0 8px;\n        margin-bottom: 12px !important;\n\n        @media (min-width: 900px) {\n            width: 100%;\n            max-width: 275px;\n            padding: 0;\n        }\n\n        .team-group {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n\n            @media (min-width: 900px) {\n                gap: 16px;\n            }\n        }\n    }\n\n    .pool-picks-matchup-box-seed {\n        width: 18px;\n        height: 18px;\n        background-color: #002129;\n        border: 1px solid #CA942E;\n        border-radius: 4px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        @media (min-width: 900px) {\n            width: 32px;\n            height: 32px;\n        }\n\n        p {\n            font-size: 12px;\n            font-weight: 500;\n            color: #CD942E;\n            margin: 0;\n\n            @media (min-width: 900px) {\n                font-size: 18px;\n            }\n        }\n    }\n\n    .pool-picks-matchup-box-team {\n        img {\n            width: 32px;\n            height: 32px;\n\n            @media (min-width: 900px) {\n                width: 48px;\n                height: 48px;\n            }\n        }\n    }\n\n    .pool-picks-matchup-box-vs {\n        font-size: 12px;\n        font-weight: 500;\n        color: #002129;\n\n        @media (min-width: 900px) {\n            font-size: 16px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
